module.exports = __webpack_public_path__ + "static/media/autoplay_prev.f24ff345.svg";